// extracted by mini-css-extract-plugin
export default {"feedbackList":"WhatIsNext_feedbackList__M5s2t","feedbackItem":"WhatIsNext_feedbackItem__5KUb6"};